import { useAppDispatch } from './useAppDispatcher.hook';
import { getSourceListThunk } from '../redux/Source/Source.thunk';
import { Job } from '../redux/Job/Job.type';

const useSourceHook = () => {
  const dispatch = useAppDispatch();

  return {
    getSelectList: async (
      q: string,
      loadedOptions: string | any[],
      { page }: any,
    ) => {
      const {
        payload: { data, pagination },
      } = await dispatch(getSourceListThunk({ q, page }));
      return {
        options: data.map((item: Job) => ({
          value: item.id,
          label: item.name,
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
    getSelectListByIds: async (ids: Array<number>) => {
      const {
        payload: { data },
      } = await dispatch(getSourceListThunk({ ids }));
      return data.map((item: Job) => ({
        value: item.id,
        label: item.name,
      }));
    },
  };
};

export default useSourceHook;
